// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K17d","question":"styles_question__2ukun","description":"styles_description__IrLx4"};